import { Project } from "@customink/signalmizely-core";
import { LogLevel } from "@optimizely/optimizely-sdk";
import Cookies from "js-cookie";
import { v4 as uuidv4 } from "uuid";
const SIGNALMIZELY_FORCED_COOKIE_PREFIX = "sm_f_";
const DEFAULT_USER_ID_COOKIE_NAME = "signalmizelyEndUserId";
const DEFAULT_CONFIG = {
    autoUpdate: true,
    updateInterval: 300000, // 5 minutes in milliseconds
    logLevel: LogLevel.ERROR,
    userIdCookieName: DEFAULT_USER_ID_COOKIE_NAME,
};
export class Helpers {
    projectPromise = null;
    config;
    constructor(config) {
        this.config = { ...DEFAULT_CONFIG, ...config };
    }
    async getProject() {
        if (!this.projectPromise) {
            this.projectPromise = Project.initialize({
                sdkKey: this.config.sdkKey,
                options: {
                    autoUpdate: this.config.autoUpdate,
                    updateInterval: this.config.updateInterval,
                    logLevel: this.config.logLevel,
                },
            });
        }
        return await this.projectPromise;
    }
    async flagDecision(flagKey, options = {}) {
        const signalmizelyProject = await this.getProject();
        const resolvedUserId = options.userId || this.getSignalmizelyUserId();
        const variationOverride = this.getSignalmizelyVariationOverride(flagKey);
        const decisionOptions = {
            variationOverride: variationOverride,
            attributes: options.attributes,
            sendImpression: options.sendImpression,
        };
        const decision = await signalmizelyProject.decision(flagKey, resolvedUserId, decisionOptions);
        return decision;
    }
    async flagVariation(flagKey, options = {}) {
        const decision = await this.flagDecision(flagKey, options);
        return decision.variationKey;
    }
    async close() {
        if (this.projectPromise) {
            const project = await this.projectPromise;
            await project.close();
            this.projectPromise = null;
        }
    }
    getEffectiveCookieDomain() {
        const hostname = window.location.hostname;
        const hostArray = hostname.split(".");
        if (hostArray.includes("localhost")) {
            return undefined;
        }
        else if (/\d$/.test(hostArray[hostArray.length - 1])) {
            return hostname;
        }
        else {
            const domain = "." +
                (hostArray.length > 1 ? hostArray.slice(-2).join(".") : hostArray[0]);
            return domain;
        }
    }
    getSignalmizelyUserId() {
        let userId = Cookies.get(this.config.userIdCookieName);
        if (!userId) {
            userId = uuidv4();
            const expiresDays = 6 * 30; // 6 months in days (approx)
            const cookieOptions = {
                expires: expiresDays,
                path: "/",
            };
            const effectiveDomain = this.getEffectiveCookieDomain();
            if (effectiveDomain) {
                cookieOptions.domain = effectiveDomain;
            }
            Cookies.set(this.config.userIdCookieName, userId, cookieOptions);
        }
        return userId;
    }
    getSignalmizelyVariationOverride(key) {
        return Cookies.get(`${SIGNALMIZELY_FORCED_COOKIE_PREFIX}${key}`) || undefined;
    }
}
